import React, { useState } from 'react';

import Show from 'components/Show';
import Action from 'components/Misc/Action';
import { Title } from 'components/Misc/Typography';

import Add from 'containers/Administrator/Users/Create/Parent/Children/Add';
import Child from 'containers/Administrator/Users/Create/Parent/Children/Child';

import { useUserCreateStore } from 'store/user/useUserCreateStore';

const Children = () => {
	// Use user's creation store
	const children = useUserCreateStore(state => state.user.children);

	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	return (
		<>
			<Title
				title="Bērni"
				className="text-xl"
			/>

			{/* Parent's selected children */}
			<Show if={children?.length}>
				<div className="grid gap-4 md:grid-cols-2">
					{children?.map(child =>
						<Child key={child.id} child={child} isSelected={true} />
					)}
				</div>
			</Show>
			
			{/* Parent's modal toggle */}
			<Action
				icon="person_add"
				title="Pievienot bērnu"
				subtitle="Piesaistiet vecākam bērnus"
				onClick={handleModal}
			/>

			{/* Child selection modal */}
			<Add modal={modal} handleModal={handleModal} />
		</>
	);
};

export default Children;